import { useLang } from "@/i18n/LanguageContext";

const Row = ({ items, hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap font-display text-2xl italic tracking-wide text-cream/80 sm:text-3xl">{item}</span>
        <span className="mx-8 inline-block h-1.5 w-1.5 rotate-45 bg-gold/70" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  const { t } = useLang();
  return (
    <div className="relative overflow-hidden border-y border-gold/15 bg-abyss/60 py-6" data-testid="brand-marquee">
      <div className="flex w-max animate-marquee">
        <Row items={t.marquee} />
        <Row items={t.marquee} hidden />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
    </div>
  );
}
